export const matchWithOption = option => option?.id ?? option;
